import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-right-bar', 'ArrowRightBar', [["path",{"d":"M18 15l3 -3l-3 -3"}],["path",{"d":"M3 12h18"}],["path",{"d":"M3 9v6"}]]);